<div>
    <div>
        <div>
            <mat-form-field>
                <input [(ngModel)]="data.name" aria-label="Tag" matInput placeholder="Tag" />
            </mat-form-field>
        </div>
    </div>
</div>
<div class="mt-2 text-center">
    <button
        (click)="onConfirmClick()"
        class="mr-1"
        color="accent"
        mat-flat-button
    >
        Add Tag
    </button>
    <button (click)="onCancelClick()" mat-stroked-button>Cancel</button>
</div>